import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Car, BarChart3, MapPin, Clock, Shield, Settings } from 'lucide-react';
import '../styles/Pages.css';

const FleetManagement = () => {
  const features = [
    {
      icon: <Car size={24} />,
      title: 'Gestión Integral de Vehículos',
      description: 'Administra toda la información de tus vehículos: datos técnicos, documentación, asignaciones y más.'
    },
    {
      icon: <MapPin size={24} />,
      title: 'Seguimiento en Tiempo Real',
      description: 'Visualiza la ubicación exacta de cada vehículo de tu flota en tiempo real desde cualquier dispositivo.'
    },
    {
      icon: <BarChart3 size={24} />,
      title: 'Análisis de Rendimiento',
      description: 'Obtén informes detallados sobre el rendimiento de tu flota: consumo de combustible, tiempos de inactividad, eficiencia de rutas y más.'
    },
    {
      icon: <Clock size={24} />,
      title: 'Mantenimiento Preventivo',
      description: 'Programa y controla los mantenimientos de tus vehículos basados en kilometraje o tiempo para prevenir averías.'
    },
    {
      icon: <Shield size={24} />,
      title: 'Seguridad Avanzada',
      description: 'Protege tu flota con alertas de movimiento no autorizado, exceso de velocidad y bloqueo remoto de motor.'
    },
    {
      icon: <Settings size={24} />,
      title: 'Personalización Total',
      description: 'Adapta la plataforma a tus necesidades específicas con opciones de configuración flexibles.'
    }
  ];

  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Gestión de Flota</h1>
            <p>Solución integral para la administración eficiente de tu flota vehicular</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="page-grid">
              <div className="page-text">
                <h2>Control Total de tu Flota</h2>
                <p>Nuestra solución de gestión de flota te proporciona todas las herramientas necesarias para administrar eficientemente tus vehículos, optimizar rutas, reducir costos operativos y mejorar la seguridad.</p>
                <p>Con VillaTracking, tendrás acceso a información en tiempo real sobre la ubicación y estado de cada vehículo, podrás generar informes detallados sobre el rendimiento de tu flota y programar mantenimientos preventivos para evitar costosas averías.</p>
                <Link to="/#contact" className="btn btn-primary">Solicitar Demo</Link>
              </div>
              <div className="page-image">
                <img src="img/benefits1.webp" alt="Gestión de Flota" />
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <h2 className="text-center">Características Principales</h2>
            <div className="features-grid-3">
              {features.map((feature, index) => (
                <div className="feature-card" key={index}>
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="page-grid">
              <div className="page-image">
                <img src="img/carousel3.webp" alt="Dashboard de Gestión" />
              </div>
              <div className="page-text">
                <h2>Dashboard Personalizable</h2>
                <p>Nuestro dashboard intuitivo te permite visualizar toda la información relevante de tu flota en un solo lugar. Personaliza los widgets según tus necesidades para tener siempre a la vista los indicadores más importantes para tu operación.</p>
                <ul className="feature-list">
                  <li>Mapa interactivo con la ubicación de todos tus vehículos</li>
                  <li>Indicadores de rendimiento en tiempo real</li>
                  <li>Alertas y notificaciones importantes</li>
                  <li>Resumen de mantenimientos programados</li>
                  <li>Estadísticas de consumo de combustible</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <h2 className="text-center">Beneficios para tu Empresa</h2>
            <div className="benefits-columns">
              <div className="benefit-column">
                <h3>Reducción de Costos</h3>
                <ul>
                  <li>Disminución del consumo de combustible</li>
                  <li>Optimización de rutas y tiempos de entrega</li>
                  <li>Reducción de mantenimientos correctivos</li>
                  <li>Menor desgaste de vehículos</li>
                  <li>Disminución de horas extra innecesarias</li>
                </ul>
              </div>
              <div className="benefit-column">
                <h3>Aumento de Productividad</h3>
                <ul>
                  <li>Mejor planificación de rutas y entregas</li>
                  <li>Reducción de tiempos de inactividad</li>
                  <li>Asignación eficiente de vehículos</li>
                  <li>Automatización de procesos administrativos</li>
                  <li>Respuesta rápida ante imprevistos</li>
                </ul>
              </div>
              <div className="benefit-column">
                <h3>Mayor Seguridad</h3>
                <ul>
                  <li>Prevención de robos y usos no autorizados</li>
                  <li>Monitoreo de comportamientos de conducción</li>
                  <li>Alertas de exceso de velocidad</li>
                  <li>Botón de pánico para emergencias</li>
                  <li>Bloqueo remoto de motor</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-cta">
          <div className="container">
            <h2>Optimiza la gestión de tu flota hoy mismo</h2>
            <p>Solicita una demostración personalizada de nuestra plataforma</p>
            <Link to="/#contact" className="btn btn-primary btn-lg">Solicitar Demo</Link>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default FleetManagement;